module.exports = __webpack_public_path__ + "img/9.e301ac2a.png";